import icon_closed from '@assets/images/icon-eye-closed.svg'
import icon_opened from '@assets/images/icon-eye-opened.svg'
import styled, { createGlobalStyle } from 'styled-components'

const Button = styled.button`
  background: no-repeat center;
  background-image: url(${props => (props.visible ? icon_closed : icon_opened)});
  background-position-y: ${props => (props.visible ? '3px' : '4.5px')};
  width: 22px;
  height: 22px;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
  cursor: pointer;
`
const CustomStyle = createGlobalStyle`
  .aberto.input-password.error button {
    top: 14px;
  }
`

export { Button, CustomStyle }
